import { Grid, Stack, Box } from '@mui/material'
import { EntitlementCard } from '../MyRequestsEntitlementCard/components'
import FullComponentLoadingIcon from '../../shared/UI/LoadingIndicator/FullComponentLoadingIcon'
import Paragraph from '../../shared/UI/Paragraph'
import OSPNotificationWithApproval from './ManAuthPayApprovalBanner'
import NumberInput from '../../shared/UI/NumberInput'

type Props = {
  entitlementValue?: number | null
  usedValue?: number | null
  remainingValue?: number | null
  loading?: boolean
  onApprovalHoursChange?: (value: number | null) => void
  approvalHoursValue?: number | null
  exceededHours?: number
  absenceTypeId?: number
  isManAuthRequest?: boolean
}

function OSPEntitlementCard({
  entitlementValue = 0,
  usedValue = 0,
  remainingValue = 0,
  loading = false,
  onApprovalHoursChange,
  approvalHoursValue = null,
  exceededHours = 40,
  absenceTypeId,
  isManAuthRequest = false
}: Props) {
  const safeEntitlementValue = entitlementValue ?? 0
  const safeUsedValue = usedValue ?? 0
  const safeRemainingValue = remainingValue ?? 0

  return (
    <FullComponentLoadingIcon loading={loading} sx={{ border: '1px solid #EEEEEE' }}>
      <EntitlementCard hasEntitlementSplit topColor="#F7F7F7" bottomColor="#FFFFFF" radius="16px">
        <Grid container>
          <Grid item xs={12}>
            <Stack direction="row" spacing={2}>
              <Stack width="33%" spacing={2} alignItems="center">
                <Paragraph
                  weight="bold"
                  size="13px"
                  padding="16px 24px"
                  sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                  OSP Entitlement
                </Paragraph>
                <Paragraph size="13px" padding="0 24px 16px 24px">
                  {safeEntitlementValue.toFixed(2)}
                </Paragraph>
              </Stack>
              <Stack width="33%" spacing={2} alignItems="center">
                <Paragraph
                  weight="bold"
                  size="13px"
                  padding="16px 24px"
                  sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                  Used
                </Paragraph>
                <Paragraph size="13px" padding="0 24px 16px 24px">
                  {safeUsedValue.toFixed(2)}
                </Paragraph>
              </Stack>
              <Stack width="33%" spacing={2} alignItems="center">
                <Paragraph
                  weight="bold"
                  size="13px"
                  padding="16px 24px"
                  sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                  Remaining
                </Paragraph>
                <Paragraph size="13px" padding="0 24px 16px 24px">
                  {safeRemainingValue.toFixed(2)}
                </Paragraph>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </EntitlementCard>

      {isManAuthRequest && (
        <>
          <OSPNotificationWithApproval
            exceededHours={exceededHours}
            onApprovalHoursChange={onApprovalHoursChange}
            absenceTypeId={absenceTypeId}
          />

          <Box sx={{ marginLeft: '24px', marginRight: '24px', marginBottom: '24px' }}>
            <NumberInput
              label="Hours for approval"
              id="hours-for-approval"
              max={exceededHours}
              value={approvalHoursValue}
              size="small"
              fullWidth
              onChange={onApprovalHoursChange}
              showMaxValue
              sx={{
                '& .MuiOutlinedInput-root': {
                  height: '48px',
                },
                '& .MuiOutlinedInput-input': {
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  padding: '0 14px',
                },
                '& .MuiInputLabel-outlined': {
                  transform: 'translate(14px, 14px) scale(1)',
                },
                '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
                  transform: 'translate(14px, -6px) scale(0.75)',
                },
              }}
            />
          </Box>
        </>
      )}
    </FullComponentLoadingIcon>
  )}

export default OSPEntitlementCard
